/* 361 Sleep chat assistant.
   Answers from the store's own data: product copy, specs, FAQ and live prices (sections/chat-data.liquid)
   plus the general answers in locale bot.* (snippets/chat-bot.liquid). No outside service. */
(() => {
  const fab = document.getElementById("botFab"), panel = document.getElementById("botPanel");
  const confEl = document.getElementById("botConf");
  if (!fab || !panel || !confEl) return;
  // Shopify's t filter HTML-escapes apostrophes and ampersands; decode once so esc() below doesn't double them.
  const deco = document.createElement("textarea");
  const unent = (v) => typeof v === "string" ? ((deco.innerHTML = v), deco.value) : Array.isArray(v) ? v.map(unent) : v && typeof v === "object" ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, unent(x)])) : v;
  const C = unent(JSON.parse(confEl.textContent)), T = C.t;
  const log = document.getElementById("botLog"), form = document.getElementById("botForm"), q = document.getElementById("botQ");
  const S = window.SHOP || {}, SITE = () => window.SITE;
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const fill = (s, o) => s.replace(/\{(\w+)\}/g, (_, k) => o[k] ?? "");
  const KEY = "bot361:" + (S.lang || "ar");
  let DATA = null, loading = null, history = [];

  /* ---------- text matching ---------- */
  const norm = (s) => String(s || "").toLowerCase()
    .replace(/[ً-ٰٟـ]/g, "")           // harakat, tatweel
    .replace(/[أإآٱ]/g, "ا").replace(/ى/g, "ي").replace(/ة/g, "ه").replace(/ؤ/g, "و").replace(/ئ/g, "ي")
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[^\p{L}\p{N}\s]/gu, " ").replace(/\s+/g, " ").trim();
  const stem = (w) => {
    if (/^[a-z0-9]+$/.test(w)) return w.length > 4 ? w.replace(/(ing|es|s)$/, "") : w;
    let x = w;
    for (const p of ["وال", "بال", "فال", "كال", "لل", "ال"]) if (x.startsWith(p) && x.length - p.length >= 2) { x = x.slice(p.length); break; }
    if (x.length > 3 && /^[وفب]/.test(x)) x = x.slice(1);
    if (x.length > 3) x = x.replace(/(ها|هم|كم|ك|ه|ي|ات|ين|ون)$/, "");
    return x;
  };
  const toks = (s) => norm(s).split(" ").filter((w) => w.length > 1).map(stem);
  const STOP = new Set(["هل", "كم", "متى", "وين", "how", "when", "where", "في", "من", "علي", "عن", "مع", "او", "ما", "وش", "ايش", "شو", "كيف", "هي", "هو", "انا", "ابي", "ودي", "عندي", "the", "a", "is", "it", "do", "does", "can", "i", "my", "of", "to", "for", "and", "you", "with", "what", "how", "this"]);
  const hits = (words, kw) => { const k = toks(kw); let n = 0; for (const w of words) if (k.some((x) => x === w || (x.length > 3 && w.length > 3 && (x.startsWith(w) || w.startsWith(x))))) n++; return n; };
  const has = (text, kw) => hits(toks(text), kw) > 0;

  /* ---------- rendering ---------- */
  const scroll = () => { log.scrollTop = log.scrollHeight; };
  function bubble(html, who = "ai") {
    const d = document.createElement("div"); d.className = "bot-msg " + who; d.innerHTML = html; log.appendChild(d);
    // long answers: show their start, not their end
    if (who === "ai" && d.offsetHeight > log.clientHeight * .6) log.scrollTop = d.offsetTop - log.offsetTop - 8; else scroll();
    return d;
  }
  function say(text, extra = "") { return bubble(`<p>${esc(text).replace(/\n/g, "<br>")}</p>${extra}`); }
  const chipRow = (list) => `<div class="bot-chips">${list.map(([k, label]) => `<button type="button" data-ask="${esc(k)}">${esc(label)}</button>`).join("")}</div>`;
  const mainChips = () => chipRow(Object.entries(T.chips).map(([k, v]) => ["chip:" + k, v]));
  function card(p) {
    const add = p.av && p.vid ? `<button type="button" class="btn btn-sand" data-bot-add="${p.vid}" data-img="${esc(p.img)}">${esc(T.add)}</button>` : "";
    return `<div class="bot-card"><a href="${esc(p.u)}"><img src="${esc(p.img)}" alt="" loading="lazy"></a><div><b><bdi>${esc(p.t)}</bdi></b>${p.tag ? `<span class="small">${esc(p.tag)}</span>` : ""}<span class="bot-price">${p.p} ${p.w || ""}</span>
      <div class="bot-act">${add}<a class="btn btn-glass" href="${esc(p.u)}">${esc(T.view)}</a></div></div></div>`;
  }
  const cards = (list) => `<div class="bot-cards">${list.map(card).join("")}</div>`;
  function typing() { const d = bubble('<span class="bot-dots"><i></i><i></i><i></i></span>'); d.classList.add("typing"); return d; }

  /* ---------- data ---------- */
  function load() {
    if (DATA) return Promise.resolve(DATA);
    if (!loading) loading = fetch(C.data, { credentials: "same-origin" }).then((r) => r.text()).then((html) => {
      const m = html.match(/<script type="application\/json" id="botData">([\s\S]*?)<\/script>/);
      const d = m ? JSON.parse(m[1]) : { products: [] };
      d.products = unent(d.products);
      d.products.forEach((p) => { ["hl", "specs", "faq", "vars"].forEach((k) => (p[k] = (p[k] || []).filter(Boolean))); p.tagset = new Set(String(p.tags).split(",").map((x) => x.trim()).filter(Boolean)); });
      DATA = d; return d;
    }).catch(() => (DATA = { products: [] }));
    return loading;
  }
  const byHandle = (h) => DATA.products.find((p) => p.h === h);

  /* ---------- understanding ---------- */
  function findProducts(words, raw) {
    const out = [];
    for (const [h, a] of Object.entries(C.alias)) {
      const p = byHandle(h); if (!p) continue;
      let s = hits(words, a.kw) + hits(words, p.t) * 0.6;
      if (a.neg && a.neg !== "-" && hits(words, a.neg)) s -= 2;
      if (s > 0) out.push([s, p]);
    }
    for (const p of DATA.products) if (!C.alias[p.h] && hits(words, p.t) > 1) out.push([hits(words, p.t), p]);
    return out.sort((a, b) => b[0] - a[0]).map((x) => x[1]);
  }
  function bestPair(words, pairs, min = 1) {
    let best = null, sc = 0;
    for (const pr of pairs) { const s = hits(words, pr[0]) * 2 + hits(words, pr[1]) * 0.5; if (s > sc) { sc = s; best = pr; } }
    return sc >= min * 2 ? best : null;
  }

  function answer(text) {
    const raw = norm(text), words = toks(text).filter((w) => !STOP.has(w));
    if (!words.length) return say(T.greet, mainChips());
    const prods = findProducts(words, raw);
    const kbScores = Object.entries(C.kb).map(([k, e]) => [hits(words, e.kw), k]).sort((a, b) => b[0] - a[0]);
    const want = (k) => hits(words, C.kw[k]) > 0;

    if (want("medical")) { say(T.medical); if (prods[0] && prods[0].note) say(prods[0].note); return; }
    if (want("human")) return human();
    const named = Object.values(C.alias).filter((a) => hits(words, a.kw)).length;
    if (named > 1 && hits(words, C.kb.diff.kw)) return kb("diff");
    if (prods.length) {
      const p = prods[0];
      if (p.vars.length > 1) {
        const v = p.vars.find((x) => toks(x.t).some((w) => words.includes(w)));
        if (v) return say(fill(v.a ? T.color_yes : T.color_no, { name: p.t, color: v.t }), cards([p]));
        if (want("colors")) return say(fill(T.colors, { name: p.t, list: p.vars.filter((x) => x.a).map((x) => x.t).join(S.en ? ", " : "، ") }), cards([p]));
      }
      const qa0 = bestPair(words.filter((w) => !hits([w], C.alias[p.h]?.kw || "")), p.faq.concat(p.specs));
      if (qa0 && !hits(words, "سعر بكم price cost")) return say(qa0[1], chipRow([["more:" + p.h, fill(T.faq_more, { name: p.t })]]));
      if (want("price") || want("buy")) return bubble(`<p>${esc(fill(T.price, { name: p.t, price: "@@P@@" })).replace("@@P@@", p.p)}</p>${cards([p])}`);
      const qa = bestPair(words.filter((w) => !hits([w], C.alias[p.h]?.kw || "")), p.faq.concat(p.specs.map(([k, v]) => [k, v])));
      if (qa) return say(qa[1], chipRow([["more:" + p.h, fill(T.faq_more, { name: p.t })]]));
      if (kbScores[0][0] > 0) return kb(kbScores[0][1]);
      return about(p);
    }
    if (want("pick")) return quiz();
    if (kbScores[0][0] > 0) return kb(kbScores[0][1]);
    if (want("thanks")) return say(T.thanks);
    if (want("greet")) return say(T.greet, mainChips());
    if (want("price") || want("buy")) return say(T.chips.pick, cards(DATA.products.filter((p) => p.av).slice(0, 6)));
    // last try: any product FAQ across the catalogue
    const all = DATA.products.flatMap((p) => p.faq.map((f) => [f[0], f[1], p]));
    const qa = bestPair(words, all, 2);
    if (qa) return say(qa[1], cards([qa[2]]));
    say(T.not_sure, humanLinks() + mainChips());
  }
  function kb(k) { say(C.kb[k].a, k === "diff" ? chipRow([["chip:pick", T.chips.pick]]) : ""); }
  function about(p) {
    const parts = [p.intro || p.tag].filter(Boolean);
    const hl = p.hl.length ? `<ul class="bot-list">${p.hl.map((x) => `<li>${esc(x)}</li>`).join("")}</ul>` : "";
    say(fill(T.about, { name: p.t }) + (parts.length ? "\n" + parts[0] : ""), hl + cards([p]) + (p.faq.length ? chipRow([["more:" + p.h, fill(T.faq_more, { name: p.t })]]) : ""));
  }
  function more(h) {
    const p = byHandle(h); if (!p) return;
    say(fill(T.faq_more, { name: p.t }), chipRow(p.faq.slice(0, 6).map((f, i) => [`faq:${h}:${i}`, f[0]]).concat(p.specs.length ? [[`specs:${h}`, T.specs]] : [])));
  }
  function specs(h) {
    const p = byHandle(h); if (!p) return;
    bubble(`<p><b>${esc(T.specs)}: <bdi>${esc(p.t)}</bdi></b></p><dl class="bot-specs">${p.specs.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join("")}</dl>`);
  }
  function quiz() { say(T.quiz_q, chipRow(Object.entries(T.pos).map(([k, v]) => ["pos:" + k, v]))); }
  function pos(k) {
    let list = DATA.products.filter((p) => p.tagset.has("pos:" + k) && !p.tagset.has("type:mask"));
    const none = !list.length; if (none) list = DATA.products.filter((p) => p.tagset.has("type:pillows"));
    say(none ? T.quiz_none : fill(T.quiz_a, { pos: T.pos[k] }), cards(list.slice(0, 4)));
  }
  function humanLinks() {
    const wa = C.wa ? `<a class="btn btn-sand" href="https://wa.me/${esc(C.wa)}" target="_blank" rel="noopener">${esc(T.human_wa)}</a>` : "";
    return `<div class="bot-act">${wa}<a class="btn btn-glass" href="${esc(C.contact)}">${esc(T.human_form)}</a></div><p class="small">${esc(T.human_mail)}</p>`;
  }
  function human() { say(T.human_a, humanLinks()); }

  function chip(k) {
    const [kind, a, b] = k.split(":");
    if (kind === "chip") {
      const map = { pick: quiz, mask: () => { const p = DATA.products.find((x) => x.tagset.has("type:mask")) || byHandle("dream_mask_361"); p ? about(p) : kb("diff"); }, ship: () => kb("ship"), pay: () => { kb("pay"); kb("instal"); }, returns: () => { kb("returns"); kb("trial"); }, offers: () => kb("offers"), human };
      return (map[a] || quiz)();
    }
    if (kind === "pos") return pos(a);
    if (kind === "more") return more(a);
    if (kind === "specs") return specs(a);
    if (kind === "faq") { const p = byHandle(a); const f = p && p.faq[+b]; if (f) say(f[1]); }
  }

  /* ---------- conversation flow ---------- */
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(history.slice(-30))); } catch (e) {} }
  async function ask(text, label) {
    history.push(text); save();
    bubble(`<p>${esc(label || text)}</p>`, "me");
    const t = typing();
    await load();
    await new Promise((r) => setTimeout(r, 380));
    t.remove();
    /^(chip|pos|more|specs|faq):/.test(text) ? chip(text) : answer(text);
  }
  async function replay() {
    let h = []; try { h = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch (e) {}
    say(T.hello, mainChips());
    if (!h.length) return;
    await load();
    for (const x of h) { history.push(x); bubble(`<p>${esc(labelFor(x))}</p>`, "me"); /^(chip|pos|more|specs|faq):/.test(x) ? chip(x) : answer(x); }
  }
  function labelFor(k) {
    const [kind, a, b] = k.split(":");
    if (kind === "chip") return T.chips[a] || k;
    if (kind === "pos") return T.pos[a] || k;
    if (kind === "more") { const p = DATA && byHandle(a); return p ? fill(T.faq_more, { name: p.t }) : k; }
    if (kind === "specs") return T.specs;
    if (kind === "faq") { const p = DATA && byHandle(a); return p && p.faq[+b] ? p.faq[+b][0] : k; }
    return k;
  }

  let started = false;
  function open(on = true) {
    panel.hidden = !on; fab.setAttribute("aria-expanded", String(on)); document.body.classList.toggle("bot-open", on);
    if (on) { if (!started) { started = true; replay(); } load(); setTimeout(() => q.focus({ preventScroll: true }), 60); }
    else fab.focus({ preventScroll: true });
  }
  fab.hidden = false;
  fab.addEventListener("click", () => open(panel.hidden));
  fab.addEventListener("pointerenter", () => load(), { once: true });
  document.getElementById("botClose").addEventListener("click", () => open(false));
  document.getElementById("botReset").addEventListener("click", () => { history = []; save(); log.innerHTML = ""; say(T.hello, mainChips()); });
  panel.addEventListener("keydown", (e) => { if (e.key === "Escape") open(false); });
  form.addEventListener("submit", (e) => { e.preventDefault(); const v = q.value.trim(); if (!v) return; q.value = ""; ask(v); });
  log.addEventListener("click", (e) => {
    const c = e.target.closest("[data-ask]");
    if (c) { const k = c.dataset.ask; return ask(k, c.textContent); }
    const a = e.target.closest("[data-bot-add]");
    if (a && SITE()) {
      a.disabled = true;
      SITE().addItems([{ id: Number(a.dataset.botAdd), quantity: 1 }], a.dataset.img).finally(() => (a.disabled = false));
    }
  });
})();
